export enum CrudOperationType {
  Create = 1,
  Retrieve = 2,
  Update = 4,
  Delete = 8
}
